<template>
    <Card>
        <CardArtwork class="tw-cursor-pointer" @click="goToBeatTape"
                     :src="beatTape.image(300)"></CardArtwork>
        <CardTitle :title="beatTape.title" :page-id="pageId" :subtiles="beatTape.itemsCount" :to="{name: 'beat-tape', params: {pageId: pageId, beatTape: beatTape.id}}" >
            <template v-slot:subtitle>
            <!-- Custom subtitle content -->
            <span>{{ beatTape.itemsCount + " Beats"}} </span>
            </template>
        </CardTitle>
        <CardBuyButton  :item="beatTape" />
    </Card>
</template>

<script>
import Card from "../../base/base-card/BaseCard";
import CardArtwork from "../../base/base-artwork";
import CardTitle from "../../base/base-card/BaseCardTitle";
import CardBuyButton from "../../base/base-card/BaseCardBuyButton";
import PlayButton from "../../base/base-play";
import BeatTapes from "../../../models/beat-tapes"

export default {
    components: { CardBuyButton, CardTitle, PlayButton, CardArtwork, Card },
    props: {
        beatTape: {
            type: BeatTapes,
            required: true
        }
    },
    computed: {
        buyButtonLabel() {
            if(!this.beatTape.price) return
            return "$"+this.beatTape.price
        },
        pageId() {
            return this.$store.state.currentPage.id
        },
        playerActive() {
        return this.$store.state.player.playing;
        },
        playlistManager() {
        return this.$store.state.playlistManager;
        },
        isPaused() {
        return (this.playlistManager.isPlaying(this.beatTape) && !this.playerActive);
        },
        isPlaying() {
        return (this.playlistManager.isPlaying(this.beatTape) && this.playerActive);
        },
        isActive() {
        return this.isPaused || this.isPlaying
        }
    },
    methods: {
        goToBeatTape() {
            const params = {pageId: this.pageId, beatTape: this.beatTape.id}
            this.$router.push({name: 'beat-tape', params: params})
        }
    }
}

</script>
